import { render, staticRenderFns } from "./LinkClaim.vue?vue&type=template&id=7f695420&scoped=true"
import script from "./LinkClaim.vue?vue&type=script&lang=ts"
export * from "./LinkClaim.vue?vue&type=script&lang=ts"
import style0 from "./LinkClaim.vue?vue&type=style&index=0&id=7f695420&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f695420",
  null
  
)

export default component.exports